import React, { Component } from 'react'
import { Card } from 'react-bootstrap';

class RecepcionGeneralInfo extends Component {
  render() {
    const { data = {} } = this.props;

    return (
      <Card>
        <Card.Body>
          <strong className="text-black card-label-info">Folio Fiscal: </strong>
          { data.cfdi_uuid }
          <br/>

          <strong className="text-black card-label-info">Emisor: </strong>
          { data.emisor_rfc } { data.emisor_razon_social ?? '' }
          <br/>

          <strong className="text-black card-label-info">Receptor: </strong>
          { data.receptor_rfc } { data.receptor_razon_social ?? '' }
          <br/>

          <strong className="text-black card-label-info">Total: </strong>
          { data.total }
          <br/>
        </Card.Body>
      </Card>
    )
  }
}

export default RecepcionGeneralInfo;